import React, { useEffect, useState } from "react";
import ContactHeader from "../../components/contact/ContactHeader";
import { Box, Stack } from "@mui/material";
import InternalContact from "../../components/contact/InternalContact";
import ExternalContact from "../../components/contact/ExternalContact";
import { useDispatch, useSelector } from "react-redux";
import useWorkspacePicker from "../../customHooks/useWorkspacePicker";
import { allWorkspacesSelector } from "../../utils/workspaceView";
import { requestAllWorkspacesPeople } from "../../appStore/actions/ArkchatGroup/action";
import { RECEIVED_ALL_WORKSPACE_PEOPLE } from "../../appStore/actions/ArkchatGroup/type";
import { useTranslation } from "react-i18next";
import HelperScreen from "../../common/ToolTip/HelperScreen";
import { handleCopyClick } from "../../utils/copytoClipboard";
import { showToastMsg } from "../../appStore/actions/global/action";
import useAppSelectors from "../../customHooks/useAppSelectors";
import { InviteType } from "../../utils/constant";
import { getInviteUrl } from "../../appStore/actions/subscriber/action";

const Contact = () => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { accountLevelPeople, currentUserData } = useAppSelectors();
  const allWorkspaces = useSelector(allWorkspacesSelector);
  const allWorkspacePeople = useSelector((state) => state?.arkchatgroup?.allWorkspacePeople);
  const { askWorkspace, workspacePicker } = useWorkspacePicker();
  const people = allWorkspaces ? allWorkspacePeople : accountLevelPeople;
  const [showPromt, setShowPromt] = useState(true);
  const [internalInviteLink, setInternalInviteLink] = useState("");
  const [externalInviteLink, setExternalInviteLink] = useState("");
  const [isInviteLoading, setIsInviteLoading] = useState(false);

  const dispatch = useDispatch();

  const handleGetInviteLink = async (type) => {
    const res = await dispatch(getInviteUrl(type));
    const inviteMessage = res?.data?.inviteMessage;

    if (type === InviteType.internal) {
      setInternalInviteLink(inviteMessage);
    } else if (type === InviteType.external) {
      setExternalInviteLink(inviteMessage);
    }
  };

  const handleCopyInvite = async (type) => {
    // The links are of the active workspace, so with "All" shown they're
    // fetched for the workspace chosen.
    if (allWorkspaces) {
      const workspace = await askWorkspace({ title: "Invite people to which workspace?" });
      if (!workspace) return;
      const res = await dispatch(getInviteUrl(type));
      handleCopyClick(res?.data?.inviteMessage, handleCopyClickCallback);
      return;
    }
    if (internalInviteLink || externalInviteLink) {
      if (type === InviteType?.external) {
        handleCopyClick(externalInviteLink, handleCopyClickCallback);
      } else if (type === InviteType?.internal) {
        handleCopyClick(internalInviteLink, handleCopyClickCallback);
      }
    } else {
      dispatch(showToastMsg(appContent?.KEY52));
    }
  };

  const handleCopyClickCallback = (type) => {
    if (type === "error") {
      dispatch(showToastMsg(appContent?.KEY52));
    } else {
      dispatch(showToastMsg(appContent?.KEY53));
    }
  };
  
  const fetchInviteLinks = async () => {
    setIsInviteLoading(true);
    await handleGetInviteLink(InviteType.internal);
    await handleGetInviteLink(InviteType.external);
    setIsInviteLoading(false);
  };

  useEffect(() => {
    if (!allWorkspaces) fetchInviteLinks();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allWorkspaces]);

  // Only while it's shown: it loads every workspace's team.
  const workspaceCount = currentUserData?.subscribedTo?.length;
  useEffect(() => {
    if (!allWorkspaces || !workspaceCount) return undefined;
    dispatch(requestAllWorkspacesPeople());
    return () => dispatch({ type: RECEIVED_ALL_WORKSPACE_PEOPLE, payload: null });
  }, [allWorkspaces, workspaceCount, dispatch]);

  const contactTooltipSections = [
    {
      heading: appContent?.KEY15,
      content: [appContent?.KEY158],
    },
    {
      heading: appContent?.KEY16,
      content: [appContent?.KEY159],
    },
    {
      heading: appContent?.KEY160,
      content: [appContent?.KEY161],
    },
    {
      heading: appContent?.KEY162,
      content: [appContent?.KEY163],
    },
    {
      heading: appContent?.KEY164,
      content: [],
    },
  ];

  return (
    <div style={{ height: "calc(100vh - 4rem)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {!currentUserData?.tooltipContactsScreeenWeb && (
        <HelperScreen
          isContact={true}
          updateKey={"tooltip_contacts_screeen_web"}
          contactSections={contactTooltipSections}
        />
      )}
      {workspacePicker}
      <ContactHeader showPromt={showPromt} setShowPromt={setShowPromt} />
      <Box flex={1} overflow="hidden">
        <Stack direction="row" height="100%">
          <Box width={"50%"} borderRight={"1px solid black"} height="100%">
            <InternalContact
              currentUserData={currentUserData}
              accountLevelPeople={people}
              allWorkspaces={allWorkspaces}
              askWorkspace={askWorkspace}
              handleCopyInvite={handleCopyInvite}
              showPromt={showPromt}
              isInviteLoading={isInviteLoading}
            />
          </Box>
          <Box width={"50%"} height="100%">
            <ExternalContact
              currentUserData={currentUserData}
              accountLevelPeople={people}
              allWorkspaces={allWorkspaces}
              askWorkspace={askWorkspace}
              handleCopyInvite={handleCopyInvite}
              showPromt={showPromt}
              isInviteLoading={isInviteLoading}
            />
          </Box>
        </Stack>
      </Box>
    </div>
  );
};

export default Contact;
